import util from './util';

/**
 * This function fixes a bug on Safari related to img tags with srcset attributes. For unknown reasons,
 * Safari set the height of images to 0 if they have the srset attribute and are loaded by AJAX through
 * InfiniyScroll. This function forces a rerender of those images.
 */
export const shouldRerenderSrcsetImages = () => {
  if (util.isSafari()) {
    window.infinityscroll.on('new-content-loaded', (content) => {
      content.querySelectorAll('img[srcset]:not([data-srcset])').forEach((img) => {
        // eslint-disable-next-line no-self-assign, no-param-reassign
        img.outerHTML = img.outerHTML;
      });
    });
  }
}
